import React from 'react';

interface FormErrorProps {
  message: string;
  className?: string;
}

export const FormError: React.FC<FormErrorProps> = ({
  message,
  className = '',
}) => {
  if (!message) return null;

  return (
    <div
      className={`bg-[rgba(255,0,0,0.05)] border border-[#CA2C2C] text-[#CA2C2C] p-2.5 rounded mb-4 text-center text-sm font-medium break-words overflow-anywhere ${className}`}
    >
      {message}
    </div>
  );
};
